<script lang="ts" setup>
  import type { Option } from './CBlockRadioButtonGroup.types'

  withDefaults(
    defineProps<{
      options: Option[]
    }>(),
    {}
  )

  const value = defineModel<number | null | undefined>({
    default: null,
    required: true
  })

  function handleClick(optionValue: number) {
    value.value = optionValue
  }
</script>

<template>
  <div class="c-block-radio-button-group">
    <div v-for="option in options" :key="option.value" class="c-block-radio-button">
      <CButton
        :variant="value === option.value ? 'primary' : 'secondary'"
        @click="handleClick(option.value)"
        @keydown.enter="handleClick(option.value)"
      >
        {{ option.label }}
      </CButton>
      <span v-if="option.message" class="body-small-strong">{{ option.message }}</span>
    </div>
  </div>
</template>

<style lang="scss" scoped>
  .c-block-radio-button-group {
    display: grid;
    gap: 12px;

    grid-template-columns: repeat(2, 1fr);

    .c-block-radio-button {
      display: flex;
      flex-direction: column;
      gap: 4px;
      margin-bottom: auto;

      span {
        margin: 4px auto;
        text-transform: uppercase;
        text-align: center;
      }
    }
  }
</style>
